<template>
  <div>
    <admin-org-select v-if="isAdmin" class="my-3"/>
    <teacher-manage/>
  </div>
</template>
<script>
import { } from 'mdbvue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import TeacherManage from '../../staffCommon/TeacherManage.vue';
import AdminOrgSelect from '../../../components/admin/AdminOrgSelect.vue';
export default {
  name: 'StaffTeacherManagePage',
  components: { TeacherManage, AdminOrgSelect },
  data: () => ({
    org: {},
    training: {}
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapGetters('auth', ['isAdmin'])
  }
}
</script>
